import ResultDetails from './ResultDetails';
import { SampleResultSchema } from '@/zod_schemas';
import { type SampleSearchResult } from '@/api/sample/types';

interface SampleResultsProps {
  selectedSample: SampleSearchResult | null;
  resultData: SampleResultSchema[];
  searchCompleted: boolean;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
}
const SampleResults = ({
  selectedSample,
  resultData,
  searchCompleted,
  isLoading,
  isError,
  onRetry,
}: SampleResultsProps) => (
  <ResultDetails
    selectedSample={selectedSample}
    resultData={resultData}
    searchCompleted={searchCompleted}
    isLoading={isLoading}
    isError={isError}
    onRetry={onRetry}
  />
);

export default SampleResults;
